module.exports = __webpack_public_path__ + "img/skills.2c49daa3.svg";